import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaCalendar } from 'react-icons/fa';
import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import FormGroupPart from './FormGroupPart';
import NumberInput from '../../input/NumberInput';
import InputGroupWrapper from '../../InputGroupWrapper';

import messages from '../registrationMessages';
import DurationDaysInfoPart from './DurationDaysInfoPart';

const DurationDaysFormGroup = ({
  duration,
  userId,
  date,
  isAfternoon,
  resourceType,
  onChange,
  disabled,
  max,
  intl,
  showValidation,
}) => (
  <div className="form-group">
    <FormGroupPart
      label={messages.Duration}
      invalid={showValidation && (!duration || duration <= 0 || (max && duration > max))}
    >
      <InputGroupWrapper className="input-group-sm" right={intl.formatMessage(messages.Days)}>
        <NumberInput
          id="durationDaysField"
          min={1}
          max={200}
          disabled={disabled}
          value={duration}
          onChange={onChange}
          className="form-control input-sm"
        />
      </InputGroupWrapper>
    </FormGroupPart>
    <div className="col-sm-6">
      <DurationDaysInfoPart {...{ duration, userId, date, isAfternoon, resourceType, intl }} />
    </div>
  </div>
);
DurationDaysFormGroup.propTypes = {
  duration: PropTypes.number,
  resourceType: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showValidation: PropTypes.bool,
  intl: intlShape.isRequired,
};
DurationDaysFormGroup.defaultProps = {
  duration: 0,
  resourceType: null,
  disabled: false,
  showValidation: false,
};
export default DurationDaysFormGroup;
